import { render, staticRenderFns } from "./SectorTab.vue?vue&type=template&id=22c91712&scoped=true"
import script from "./SectorTab.vue?vue&type=script&lang=ts"
export * from "./SectorTab.vue?vue&type=script&lang=ts"
import style0 from "./SectorTab.vue?vue&type=style&index=0&id=22c91712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c91712",
  null
  
)

export default component.exports